import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Common Pages
import Home from '../pages/Home';
// import About from '../pages/About';
// import Appointment from '../pages/Appointment';
import Error from '../pages/Error';
import Contact from '../pages/Contact';
// import Faq from '../pages/Faq';
// import Pricing from '../pages/Pricing';

// Project Pages
// import Project from '../pages/Project';
// import Project_Slider from '../pages/Project_Slider';
// import Project_Mesonary from '../pages/Project_Mesonary';
// import Project_Mesonary_v2 from '../pages/Project_Mesonary_v2';
// import Project_Details from '../pages/Project_Details';
// import Project_Details_v2 from '../pages/Project_Details_v2';

// // Services Pages
// import Service from '../pages/Service'
// import Service_Details from '../pages/Service_Details';

// // Team Pages
// import Team from '../pages/Team';
// import Team_Details from '../pages/Team_Details';
// import Team_Two from '../pages/Team_Two';

// // Blog Pages
// import Blog from '../pages/Blog';
// import Blog_Col_1 from '../pages/Blog_Col_1';
// import Blog_Col_2 from '../pages/Blog_Col_2';
// import Blog_Details from '../pages/Blog_Details';
// import Blog_Details_v2 from '../pages/Blog_Details_v2';

// Home Pages
import Agency_Demo from '../pages/Agency_Demo';
// import Company_Demo from '../pages/Company_Demo';
// import Construction_Demo from '../pages/Construction_Demo';
// import Construction_Two_Demo from '../pages/Construction_Two_Demo';
// import Corporate_Demo from '../pages/Corporate_Demo';
import Financial_Demo from '../pages/Financial_Demo';
import Marketing_Demo from '../pages/Marketing_Demo';
import ITConsulting from '../pages/ITConsulting';
import TrainingInternship from '../pages/TrainingInternship';
import AdminRoutes from '../admin/AdminRoutes';

// import Startup_Demo from '../pages/Startup_Demo';

//Home Pages 2 
// import Onepage_Agency from '../pages/Onepage_Agency';
// import Onepage_Company from '../pages/Onepage_Company';
// import Onepage_Construction from '../pages/Onepage_Construction';
// import Onepage_Construction_Two from '../pages/Onepage_Construction_Two';
// import Onepage_Corporate from '../pages/Onepage_Corporate';
// import Onepage_Financial from '../pages/Onepage_Financial';
// import Onepage_Marketing from '../pages/Onepage_Marketing';
// import Onepage_Startup from '../pages/Onepage_Startup';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Home Demos */}
      <Route path="/agency" element={<Agency_Demo />} />
      {/* <Route path="/company" element={<Company_Demo />} /> */}
      {/* <Route path="/construction" element={<Construction_Demo />} />
      <Route path="/construction-two" element={<Construction_Two_Demo />} />
      <Route path="/corporate" element={<Corporate_Demo />} /> */}
      <Route path="/financial" element={<Financial_Demo />} />
      <Route path="/marketing" element={<Marketing_Demo />} />
      <Route path="/itconsulting" element={<ITConsulting />} /> 
      <Route path="/training-internship" element={<TrainingInternship />} />
      {/* <Route path="/startup" element={<Startup_Demo />} /> */}

      {/* Home Pages 2 */}
      {/* <Route path='/onepage/agency' element={<Onepage_Agency/>}/>
      <Route path='/onepage/company' element={<Onepage_Company/>}/>
      <Route path='/onepage/construction' element={<Onepage_Construction/>}/>
      <Route path='/onepage/construction-two' element={<Onepage_Construction_Two/>}/>
      <Route path='/onepage/corporate' element={<Onepage_Corporate/>}/>
      <Route path='/onepage/financial' element={<Onepage_Financial/>}/>
      <Route path='/onepage/marketing' element={<Onepage_Marketing/>}/>
      <Route path='/onepage/startup' element={<Onepage_Startup/>}/> */}

      {/* Blog Routes */}
      {/* <Route path="/blog" element={<Blog />} />
      <Route path="/blog/col-1" element={<Blog_Col_1 />} />
      <Route path="/blog/col-2" element={<Blog_Col_2 />} />
      <Route path="/blog/details" element={<Blog_Details />} />
      <Route path="/blog/details-v2" element={<Blog_Details_v2 />} /> */}

      {/* Service Routes */}
      {/* <Route path="/service" element={<Service />} />
      <Route path="/service/details" element={<Service_Details />} /> */}

      {/* Project Routes */}
      {/* <Route path="/project" element={<Project />} />
      <Route path="/project/slider" element={<Project_Slider />} />
      <Route path="/project/mesonary" element={<Project_Mesonary />} />
      <Route path="/project/mesonary-v2" element={<Project_Mesonary_v2 />} />
      <Route path="/project/details" element={<Project_Details />} />
      <Route path="/project/details-v2" element={<Project_Details_v2 />} /> */}

      {/* Team Routes */}
      {/* <Route path="/team" element={<Team />} />
      <Route path="/team/details" element={<Team_Details />} />
      <Route path="/team/v2" element={<Team_Two />} /> */}

      {/* Common Pages */}
      <Route path="/" element={<Home />} />
      {/* <Route path="/about" element={<About />} /> */}
      {/* <Route path="/appointment" element={<Appointment />} /> */}
      {/* <Route path="/faq" element={<Faq />} /> */}
      <Route path="/contact" element={<Contact />} />
      {/* <Route path="/pricing" element={<Pricing />} /> */}

      {/* Admin console. Everything under /admin/* is handled inside */}
      {/* AdminRoutes, which renders its own chrome instead of the site header. */}
      <Route path="/admin/*" element={<AdminRoutes />} />

      {/* Fallback Route */}
      <Route path="*" element={<Error />} />
    </Routes>
  );
};

export default AppRoutes;